import React from 'react';
import { useDispatch } from 'react-redux';

import { analyticsFilterSlice } from '../reducer';

const AnalyticsPage = React.lazy(
  () => import(/* webpackChunkName: "analytics-page" */ './AnalyticsPage')
);

export const AnalyticsEntry: React.FC = () => {
  // TODO: (astripa) add loading screen  page
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(analyticsFilterSlice.actions.setFilterVisibility(true));
    return () => {
      dispatch(analyticsFilterSlice.actions.setFilterVisibility(false));
    }
  }, [dispatch]);

  return (
    <React.Suspense>
      <AnalyticsPage />
    </React.Suspense>
  );
};
